
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    status: String,
  },
});
